import { PaymentBrand, CardBrand } from '../types';
const cardBrandToPaymentBrandMap = {
    [CardBrand.AMEX]: PaymentBrand.AMEX,
    [CardBrand.Visa]: PaymentBrand.VISA,
    [CardBrand.MasterCard]: PaymentBrand.MASTERCARD,
    [CardBrand.Discover]: PaymentBrand.DISCOVER,
    [CardBrand.JCB]: PaymentBrand.JCB,
    [CardBrand.Diners]: PaymentBrand.DINERS,
    [CardBrand.CARTE_BLUE]: PaymentBrand.CARTE_BLUE,
    [CardBrand.ELO]: PaymentBrand.ELO,
    [CardBrand.SOLO]: PaymentBrand.SOLO,
    [CardBrand.UnionPay]: PaymentBrand.UNIONPAY,
    [CardBrand.BANCARD]: PaymentBrand.BANCARD,
    [CardBrand.ENROUTE]: PaymentBrand.ENROUTE,
    [CardBrand.MASTERO]: PaymentBrand.MAESTRO,
    [CardBrand.VISA_DELTA]: PaymentBrand.VISA,
    [CardBrand.ELECTRON]: PaymentBrand.UNKNOWN,
    [CardBrand.MAESTR_UK]: PaymentBrand.UNKNOWN,
    [CardBrand.SBI_MAESTRO]: PaymentBrand.UNKNOWN,
};
export const isCreditCardBrandMap = {
    [PaymentBrand.AMEX]: true,
    [PaymentBrand.VISA]: true,
    [PaymentBrand.MASTERCARD]: true,
    [PaymentBrand.DISCOVER]: true,
    [PaymentBrand.JCB]: true,
    [PaymentBrand.DINERS]: true,
    [PaymentBrand.CARTE_BLUE]: true,
    [PaymentBrand.ELO]: true,
    [PaymentBrand.SOLO]: true,
    [PaymentBrand.UNIONPAY]: true,
    [PaymentBrand.BANCARD]: true,
    [PaymentBrand.ENROUTE]: true,
    [PaymentBrand.MAESTRO]: true,
    [PaymentBrand.BOLETO]: false,
    [PaymentBrand.MP_OXXO]: false,
    [PaymentBrand.MERCADO_PAGO_RECURRING]: false,
    [PaymentBrand.YANDEX]: false,
    [PaymentBrand.BANK_TRANSFER]: false,
    [PaymentBrand.MP_SERFIN]: false,
    [PaymentBrand.MP_BANCOMER]: false,
    [PaymentBrand.MP_BANAMEX]: false,
    [PaymentBrand.SEPA_DIRECT_DEBIT]: false,
    [PaymentBrand.PAYPAL]: false,
    [PaymentBrand.REG_DOT_RU]: false,
    [PaymentBrand.SOFORT]: false,
    [PaymentBrand.CREDITS_PREPAID_CARD]: false,
    [PaymentBrand.SEPA_OFFLINE]: false,
    [PaymentBrand.UNKNOWN]: false,
};
export const cardBrandToPaymentBrandMapper = (cardBrand) => {
    return cardBrandToPaymentBrandMap[cardBrand];
};
//# sourceMappingURL=cardBrandToPaymentBrandMapper.js.map